var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { classNames } from "@bookingcom/bui-core/utilities/classNames";
import Text, {} from "../Text/index.js";
import useId from "../../hooks/useId.js";
import styles from "@bookingcom/bui-core/css/FormControl.module.css";
export var FormControlLabel = function (props) {
    var label = props.label, subLabel = props.subLabel, labelEndSlot = props.labelEndSlot, required = props.required, id = props.id, disabled = props.disabled, group = props.group;
    var tagName = group ? "legend" : "label";
    return (React.createElement(Text, { tagName: tagName, color: disabled ? "disabled" : "neutral", className: styles.label, attributes: { htmlFor: group ? undefined : id } },
        React.createElement("span", null,
            React.createElement(Text, { tagName: "span", variant: "emphasized_2" }, label),
            subLabel && (React.createElement(Text, { tagName: "span", variant: "body_2", color: disabled ? "disabled" : "neutral_alt", className: styles.subLabel }, subLabel)),
            required && (React.createElement(Text, { tagName: "span", variant: "body_2", color: disabled ? "disabled" : "destructive", className: styles.asterisk }, "*"))),
        labelEndSlot && (React.createElement(Text, { tagName: "span", variant: "body_2", color: disabled ? "disabled" : "neutral_alt", className: styles.labelEnd }, labelEndSlot))));
};
var FormControl = React.forwardRef(function (props, ref) {
    var id = props.id, label = props.label, subLabel = props.subLabel, labelEndSlot = props.labelEndSlot, helper = props.helper, error = props.error, success = props.success, disabled = props.disabled, required = props.required, group = props.group, children = props.children, className = props.className, attributes = props.attributes, mixin = props.mixin;
    var inputId = useId(id);
    var note = (typeof error !== "boolean" && !disabled && error) ||
        (typeof success !== "boolean" && !disabled && success) ||
        helper;
    var noteId = note ? "".concat(inputId, "-note") : undefined;
    var rootClassNames = classNames(styles.root, className);
    var tagName = group ? "fieldset" : "div";
    var fieldAttributes = {
        id: group ? undefined : inputId,
    };
    // Add aria only if the value is present so it doesn't override custom attributes passed manually with undefined
    if (noteId)
        fieldAttributes["aria-describedby"] = noteId;
    // aria-required is not supported on fieldsets unless you specify their role
    if (required && !group)
        fieldAttributes["aria-required"] = true;
    var rootAttributes = __assign(__assign({}, attributes), { ref: ref });
    // Group is using fieldset which needs attributes on its level
    if (group)
        rootAttributes = __assign(__assign({}, rootAttributes), fieldAttributes);
    var noteColor = "neutral_alt";
    if (disabled) {
        noteColor = "disabled";
    }
    else if (error) {
        noteColor = "destructive";
    }
    else if (success) {
        noteColor = "constructive";
    }
    return (React.createElement(Text, { attributes: rootAttributes, className: rootClassNames, tagName: tagName, mixin: mixin },
        label && (React.createElement(FormControlLabel, { group: group, id: inputId, label: label, subLabel: subLabel, required: required, labelEndSlot: labelEndSlot, disabled: disabled })),
        group ? children() : children(fieldAttributes),
        note && (React.createElement(Text, { variant: "small_1", className: styles.note, color: noteColor, attributes: { id: noteId, role: "alert" } }, note))));
});
export default FormControl;
